import { logoutUser } from "layouts/AuthUtils";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const Logout = () => {
  const history = useHistory();

  useEffect(() => {
    // Perform cleanup
    logoutUser();
    history.replace("/auth/signin");
  }, [history]);

  // Optionally, show a loading indicator or a simple text
  return (
    <div>Logging out...</div> // Provides visual feedback that logout is processing
  );
};

export default Logout;
